import { Question } from '..';
import { AxiosRequestBuilder } from '../../../services/axiosRequestBuilder';
import {
  ApiQuestion,
  DadosServidor,
  StatusRespostaPesquisa,
} from '../types/questionnaire.types';
import { QuestionAdapter } from '../utils/questionAdapter';

export const questionnaireService = {
  getPesquisa: async (
    workshopUId: string,
    signal?: AbortSignal
  ): Promise<Question[]> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('get')
      .setUrl('/Pesquisa/ListaQuestaoPesquisa')
      .setParams({ workshopUId })
      .setResponseType('json')
      .setSignal(signal)
      .send<ApiQuestion[]>();

    return QuestionAdapter.fromApi(data);
  },

  getDadosServidor: async (
    workshopUId: string,
    signal?: AbortSignal
  ): Promise<DadosServidor> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('get')
      .setUrl('/Pesquisa/DadosServidor')
      .setParams({ workshopUId })
      .setResponseType('json')
      .setSignal(signal)
      .send<DadosServidor>();

    return data;
  },

  getStatusPesquisa: async (
    signal?: AbortSignal
  ): Promise<StatusRespostaPesquisa> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('get')
      .setUrl('/Pesquisa/GetStatusPesquisaByUser')
      .setResponseType('json')
      .setSignal(signal)
      .send<StatusRespostaPesquisa>();

    return data;
  },

  postPesquisaResponder: async (
    respostas: any,
    // dadosServidor: any,
    eventUId: string,
    signal?: AbortSignal
  ): Promise<any> => {
    const axiosRequestBuilder = new AxiosRequestBuilder();
    const { data } = await axiosRequestBuilder
      .setMethod('post')
      .setUrl('/Pesquisa/responder')
      .setParams({ eventUId })
      .setBody({ respostas })
      .setResponseType('json')
      .setSignal(signal)
      .send<any>();

    return data;
  },
};
